(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function cartChange(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty < 0 ? 0 : qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      location.reload();
    });
  }

  document.addEventListener('click', function (e) {
    var qi = e.target.closest('.nk-qi');
    if (qi) {
      var qty = parseInt(qi.dataset.qty, 10);
      cartChange(qi.dataset.key, qty);
    }
    var rem = e.target.closest('.nk-ci-remove');
    if (rem) {
      cartChange(rem.dataset.key, 0);
    }
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function () {
  function ajaxCart(form) {
    var btn = form.querySelector('button[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    var id = idInput ? idInput.value : '';
    if (!id) {
      btn.textContent = 'Unavailable';
      setTimeout(function () { btn.textContent = btn.dataset.orig || 'Add to Cart'; }, 2000);
      return;
    }
    var orig = btn.textContent;
    btn.dataset.orig = orig;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        btn.textContent = 'Error';
      } else {
        btn.textContent = 'Added ✓';
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
      }
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    })
    .catch(function () {
      btn.textContent = 'Error';
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.nk-cart-form');
    if (!form) return;
    e.preventDefault();
    ajaxCart(form);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nunkeri-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  var overlay = document.getElementById('nk-collection-overlay');
  if (!overlay) return;

  var qv         = document.getElementById('nk-quickview');
  var qvImg      = document.getElementById('nk-qv-img');
  var qvCol      = document.getElementById('nk-qv-collection');
  var qvTitle    = document.getElementById('nk-qv-title');
  var qvPrice    = document.getElementById('nk-qv-price');
  var qvDesc     = document.getElementById('nk-qv-desc');
  var qvVid      = document.getElementById('nk-qv-vid');
  var qvLink     = document.getElementById('nk-qv-link');
  var qvIngWrap  = document.getElementById('nk-qv-ingredients');
  var qvIngText  = document.getElementById('nk-qv-ing-text');

  function openOverlay() {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  if (window.location.search.indexOf('shop=open') !== -1) {
    openOverlay();
    history.replaceState({}, '', window.location.pathname);
  }

  function closeOverlay() {
    overlay.classList.remove('active');
    if (!qv || !qv.classList.contains('active')) document.body.style.overflow = '';
  }
  function openQuickView(card) {
    if (!qv) return;
    var shortDesc   = card.dataset.desc || '';
    var fullDesc    = card.dataset.fullDesc || shortDesc;
    var ingredients = card.dataset.ingredients || '';
    qvImg.src           = card.dataset.img || '';
    qvImg.alt           = card.dataset.title || '';
    qvCol.textContent   = card.dataset.col || '';
    qvTitle.textContent = card.dataset.title || '';
    qvPrice.textContent = card.dataset.price || '';
    qvDesc.textContent  = shortDesc;
    qvVid.value         = card.dataset.vid || '';
    if (qvIngWrap) {
      if (ingredients) {
        qvIngText.innerHTML = ingredients;
        qvIngWrap.style.display = '';
      } else {
        qvIngWrap.style.display = 'none';
      }
    }
    qvLink.href         = '#';
    qvLink.dataset.shortDesc = shortDesc;
    qvLink.dataset.fullDesc  = fullDesc;
    qvLink.dataset.expanded  = 'false';
    qvLink.textContent  = 'View Full Details →';
    qvLink.style.display = (fullDesc && fullDesc !== shortDesc) ? '' : 'none';
    var atcBtn = qv.querySelector('.nk-qv-atc');
    if (atcBtn) { atcBtn.textContent = 'Add to Cart'; atcBtn.disabled = false; }
    qv.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  if (qvLink) {
    qvLink.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.dataset.expanded === 'true') {
        qvDesc.textContent = this.dataset.shortDesc || '';
        this.textContent = 'View Full Details →';
        this.dataset.expanded = 'false';
      } else {
        qvDesc.innerHTML = this.dataset.fullDesc || this.dataset.shortDesc || '';
        this.textContent = 'Show Less ↑';
        this.dataset.expanded = 'true';
      }
    });
  }
  function closeQuickView() {
    if (!qv) return;
    qv.classList.remove('active');
    document.body.style.overflow = overlay.classList.contains('active') ? 'hidden' : '';
  }

  document.getElementById('nk-ov-close').addEventListener('click', closeOverlay);
  if (qv) {
    document.getElementById('nk-qv-close').addEventListener('click', closeQuickView);
    qv.querySelector('.nk-qv-backdrop').addEventListener('click', closeQuickView);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (qv && qv.classList.contains('active')) { closeQuickView(); return; }
    if (overlay.classList.contains('active')) closeOverlay();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.nk-overlay-trigger') || e.target.closest('.btn-shop-all')) {
      e.preventDefault();
      openOverlay();
      return;
    }
    var ovCard = e.target.closest('.ov-card');
    if (ovCard && overlay.classList.contains('active')) {
      if (!e.target.closest('.nk-cart-form')) {
        e.preventDefault();
        openQuickView(ovCard);
      }
      return;
    }
    var pCard = e.target.closest('.prod-card') || e.target.closest('.product-card');
    if (pCard && !e.target.closest('.nk-cart-form')) {
      e.preventDefault();
      var _imgVal = pCard.dataset.img || '';
      if (!_imgVal || _imgVal.indexOf('Liquid error') !== -1 || _imgVal.indexOf('invalid url') !== -1) {
        var _si = pCard.querySelector('.prod-img-default, .prod-img-zoom, .product-photo');
        if (_si) pCard.dataset.img = _si.currentSrc || _si.src || '';
      }
      if (!pCard.dataset.title) {
        var _sn = pCard.querySelector('.prod-name, .product-name');
        if (_sn) pCard.dataset.title = _sn.textContent.trim();
      }
      if (!pCard.dataset.price) {
        var _sp = pCard.querySelector('.prod-price, .product-price');
        if (_sp) pCard.dataset.price = _sp.textContent.trim();
      }
      if (!pCard.dataset.desc) {
        var _sd = pCard.querySelector('.prod-tagline, .product-benefit');
        if (_sd) pCard.dataset.desc = _sd.textContent.trim();
      }
      if (!pCard.dataset.vid) {
        var _sv = pCard.querySelector('input[name="id"]');
        if (_sv && _sv.value) pCard.dataset.vid = _sv.value;
      }
      openQuickView(pCard);
    }
  });

  document.querySelectorAll('.ov-filter-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ov-filter-btn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      var filter = this.dataset.filter;
      var grid = document.getElementById('nk-ov-grid');
      document.querySelectorAll('#nk-ov-grid .ov-card').forEach(function (card) {
        card.classList.toggle('hidden', filter !== 'all' && card.dataset.collection !== filter);
      });
      var visible = document.querySelectorAll('#nk-ov-grid .ov-card:not(.hidden)').length;
      if (visible === 5 && window.innerWidth > 1024) {
        grid.style.gridTemplateColumns = 'repeat(5, 1fr)';
      } else {
        grid.style.gridTemplateColumns = '';
      }
    });
  });

  function ajaxCart(form) {
    var btn = form.querySelector('button[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    var id = idInput ? idInput.value : '';
    if (!id || id === '') {
      btn.textContent = 'Unavailable';
      setTimeout(function () { btn.textContent = btn.dataset.orig || 'Add to Cart'; }, 2000);
      return;
    }
    var orig = btn.textContent;
    btn.dataset.orig = orig;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        btn.textContent = 'Error';
      } else {
        btn.textContent = 'Added ✓';
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });
      }
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    })
    .catch(function () {
      btn.textContent = 'Error';
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    });
  }

  window.nkCartHandlerActive = true;
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.nk-cart-form');
    if (!form) return;
    e.preventDefault();
    ajaxCart(form);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nunkeri-navbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var shopBtn   = document.getElementById('nk-nav-shop');
  var searchBtn = document.getElementById('nk-nav-search');
  var searchOv  = document.getElementById('nk-search-overlay');
  var searchIn  = document.getElementById('nk-sq');
  var closeBtn  = document.getElementById('nk-sc');

  if (shopBtn) {
    shopBtn.addEventListener('click', function (e) {
      var overlay = document.getElementById('nk-collection-overlay');
      if (overlay) {
        e.preventDefault();
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  }

  /* Global fallback: any .nk-overlay-trigger on pages without the overlay */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.nk-overlay-trigger');
    if (!trigger) return;
    if (!document.getElementById('nk-collection-overlay')) {
      e.preventDefault();
      window.location.href = '/?shop=open';
    }
  });

  /* Prevent disabled nav items from navigating */
  document.querySelectorAll('.nav-item-disabled').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); });
  });

  if (searchBtn && searchOv) {
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      searchOv.classList.add('active');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (searchIn) searchIn.focus(); }, 80);
    });
    closeBtn.addEventListener('click', function () {
      searchOv.classList.remove('active');
      document.body.style.overflow = '';
    });
    searchOv.querySelector('.nk-so-backdrop').addEventListener('click', function () {
      searchOv.classList.remove('active');
      document.body.style.overflow = '';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOv.classList.contains('active')) {
        searchOv.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nunkeri-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.nkCartHandlerActive) return;
  window.nkCartHandlerActive = true;
  function ajaxCart(form) {
    var btn = form.querySelector('button[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    var id = idInput ? idInput.value : '';
    if (!id) {
      btn.textContent = 'Unavailable';
      setTimeout(function () { btn.textContent = btn.dataset.orig || 'Add to Cart'; }, 2000);
      return;
    }
    var orig = btn.textContent;
    btn.dataset.orig = orig;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        btn.textContent = 'Error';
      } else {
        btn.textContent = 'Added ✓';
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
      }
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    })
    .catch(function () {
      btn.textContent = 'Error';
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.nk-cart-form');
    if (!form) return;
    e.preventDefault();
    ajaxCart(form);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
